export default "__VITE_ASSET__BfN65EtI__"